import HeroSection from './components/HeroSection';
import BrandStrength from './components/BrandStrength';
import SolutionGrid from './components/SolutionGrid';
import NewsPreview from './components/NewsPreview';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <BrandStrength />
      <SolutionGrid />
      <NewsPreview />
    </main>
  );
}